import React, { Component } from 'react';
import { connect } from 'react-redux';
import YourPersonalRewards from '../../home/personal-rewards/index';
import PrivacyPopup from '../../common/privacy-policy/privacy-popup';
import MarketingConsentPopup from '../../common/marketing/marketing-consent-popup';
import UserGroupGuard from '../../common/guards/user-group';
import { GROUP_OWNER, GROUP_STAFF } from '../../../data/userGroups';
import CookieConsent from '../../cookie-consent/cookie-consent';

class MainPopups extends Component {
  render() {
    let {
      showPersonalRewardsSettings, showMarketingConsentPopup, showPrivacyPopup, showSaveOrderDialog
    } = this.props.viewConfig;
    const { profile } = this.props.viewConfig;
    const pseudo = profile.attributes['pseudo-login'];

    showPrivacyPopup = showPrivacyPopup && !pseudo;
    showPersonalRewardsSettings = showPersonalRewardsSettings && !showPrivacyPopup && !pseudo;
    showMarketingConsentPopup = showMarketingConsentPopup && !showPersonalRewardsSettings && !showPrivacyPopup && !pseudo;
    showSaveOrderDialog = showSaveOrderDialog && !showPrivacyPopup;

    let activePopup = '';
    if (showPrivacyPopup) {
      activePopup = 'showPrivacyPopup';
    } else if (showMarketingConsentPopup) {
      activePopup = 'showMarketingConsentPopup';
    } else if (showPersonalRewardsSettings) {
      activePopup = 'showPersonalRewardsSettings';
    } else if (showSaveOrderDialog) {
      activePopup = 'showSaveOrderDialog';
    }
    return (
      <div>
        <CookieConsent/>
        {activePopup === 'showPrivacyPopup' && <PrivacyPopup show={showPrivacyPopup}/>}

        {activePopup === 'showPersonalRewardsSettings' && <YourPersonalRewards />}

        {activePopup === 'showMarketingConsentPopup' && (
        <UserGroupGuard type={[GROUP_OWNER, GROUP_STAFF]}>
          <MarketingConsentPopup show={showMarketingConsentPopup}/>
        </UserGroupGuard>
)}

      </div>
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
  currentUser: state.currentUser.user,
  userLoading: state.currentUser.fetching,
});

export default connect(mapStateToProps)(MainPopups);



// WEBPACK FOOTER //
// ./src/components/layout/main/main-popups.jsx